/* @flow */

import * as React from 'react';

import { Button } from '@sonyged/ext-proc';

import type { ContestType } from '../redux/types';
import IceHeroThumbnail from '../../assets/images/pages/top/img_proc-ice-explain01_a.png';
import IceVennDiagram from '../../assets/images/pages/top/img_proc-ice-explain02.png';
import LoadingButton from '../components/LoadingButton';
import PizzaHeroThumbnail from '../../assets/images/pages/top/img_proc-piza-explain01_a.png';
import SushiHeroThumbnail from '../../assets/images/pages/top/img_proc-sushi-explain01_a.png';
import SushiAHeroThumbnail from '../../assets/images/pages/top/img_proc-sushi-explain01_b.png';
import PizzaAHeroThumbnail from '../../assets/images/pages/top/img_proc-piza-explain01_b.png';
import IceAHeroThumbnail from '../../assets/images/pages/top/img_proc-ice-explain01_b.png';
import PizzaVennDiagram from '../../assets/images/pages/top/img_proc-piza-explain02.png';
import ZProTitle from '../../assets/images/pages/top/img_proc-explain_title.png';
import ZkaiSonygedLogo from '../../assets/images/pages/top/img_proc-explain_logo@2x.png';
import SushiVennDiagram from '../../assets/images/pages/top/img_proc-sushi-explain02_a.png';

const THEME = {
  ice: 'ice',
  pizza: 'pizza',
  sushi: 'sushi',
  'ice-a': 'ice',
  'pizza-a': 'pizza',
  'sushi-a': 'sushi',
};

const HERO_THUMBNAIL = {
  ice: IceHeroThumbnail,
  pizza: PizzaHeroThumbnail,
  sushi: SushiHeroThumbnail,
  'ice-a': IceAHeroThumbnail,
  'sushi-a': SushiAHeroThumbnail,
  'pizza-a': PizzaAHeroThumbnail,
};

const VENN_DIAGRAM = {
  ice: IceVennDiagram,
  pizza: PizzaVennDiagram,
  sushi: SushiVennDiagram,
  'ice-a': IceVennDiagram,
  'pizza-a': PizzaVennDiagram,
  'sushi-a': SushiVennDiagram,
};

const PARENT_NOTE_12 = (
  <>
    小学1・2年生は、まずはプログラミングの楽しさを感じることが大切な時期です。身近なものを題材に、楽しく学べるデジタル学習の中で、プログラミングのエッセンスに触れていきます。論理的に考えたり、試行錯誤したりするうちに、与えられた課題を解決するおもしろさを実感。
    <span className="secondary300-color">「プログラミング的思考」を伸ばす土台が作られていきます。</span>
  </>
);

const PARENT_NOTE_34 = (
  <>
    小学3・4年生は、プログラミングとは何かを知ることで、興味を深めていくことが大切な時期です。具体的な作業をフローチャートを用いて抽象化したり、関数や変数を用いてプログラムを設計したりしながら、プログラミングのエッセンスに触れていきます。楽しく学べるデジタル学習の中で、
    <span className="secondary300-color">「プログラミング的思考」を伸ばしていきます。</span>
  </>
);

const PARENT_NOTE_56 = (
  <>
    小学5・6年生は、社会の中で活用されるプログラミングを知ることで、学びを深めていくことが大切な時期です。関数や変数、条件分岐を適切に用いながらプログラムを設計することで、プログラミングのエッセンスに触れていきます。子どもが夢中になるデジタル学習の中で、
    <span className="secondary300-color">「プログラミング的思考」をさらに伸ばします。</span>
  </>
);

const TITLE = {
  ice: 'アイスクリーム屋さんの店員になって、注文どおりにアイスクリームを作ったり売ったりします。',
  pizza: 'ピザ屋さんの店員になって、配達のルートを考えたりピザを作って売ったりします。',
  sushi: 'お寿司屋さんの店員になって、お寿司を作ったり、効率的に仕事をする方法を考えたりします。',
  'ice-a': 'アイスクリーム屋さんの店員になって、注文どおりにアイスクリームをつくったり売ったりします。',
  'pizza-a': 'ピザ屋さんの店員になって、配達のルートを考えたりピザをつくって売ったりします。',
  'sushi-a': 'おすし屋さんの店員になって、お寿司をつくったり、効率的に仕事をする方法を考えたりします。',
};

const FIELD = {
  ice: {
    title: 'ワゴンで うりに いこう',
    text: '天気や気温、曜日に合わせて場所やアイスクリームを売る値段を選び、お客さんにたくさん買ってもらえる設定を考えます。',
  },
  pizza: {
    title: 'おすすめの ピザを つくろう',
    text: 'さまざまな好みや要望を整理して、よりお客さんによろこんでもらえる「おすすめのピザ」を考えます。',
  },
  sushi: {
    title: '売れるおすしを考えよう',
    text: 'どんな人がどのお寿司を選ぶか、今までの記録を見ながら予想し、お客さんにたくさん食べてもらえるお寿司の種類と流す順番を考えます。',
  },
  'ice-a': {
    title: 'アイスクリームを仕入れて売ろう',
    text: '天気や気温、曜日に合わせて、アイスクリームを仕入れる数や販売場所、販売する値段を選び、より利益が上がる設定を考えます。',
  },
  'pizza-a': {
    title: '本日のピザを売ろう',
    text: '今までの記録と「昨日のピザ」を参考に、お客さんにたくさん食べてもらえる「本日のピザ」を考えます。',
  },
  'sushi-a': {
    title: '売れるおすしを予想しよう',
    text: 'どんな人がどのお寿司を選ぶか、今までの記録を見ながら予想し、材料費と販売価格を考慮しながら、より利益が上がるようにお寿司の種類と流す順番を考えます。',
  },
};

const PARENT_NOTE = {
  ice: PARENT_NOTE_12,
  pizza: PARENT_NOTE_12,
  sushi: PARENT_NOTE_34,
  'ice-a': PARENT_NOTE_34,
  'pizza-a': PARENT_NOTE_56,
  'sushi-a': PARENT_NOTE_56,
};

type Props = {
  kind: ContestType,
};

const HeroThumbnail = ({ kind, ...rest }: Props) => <img {...rest} src={HERO_THUMBNAIL[kind]} />;

const VennDiagram = ({ kind, ...rest }: Props) => <img {...rest} src={VENN_DIAGRAM[kind]} />;

type ZkaiPageProps = {
  kind: ContestType,
  timelines: Array<{ title: string, text: string }>,
  tagline: string,
  accepted: boolean,
  active: number | void,
  onStartClick: Function,
  is6th?: boolean,
};

type ZkaiPageState = {
  checked: boolean,
  clicked: boolean,
};

class ZkaiPage extends React.Component<ZkaiPageProps, ZkaiPageState> {
  scrollElement: any;

  constructor(props: ZkaiPageProps) {
    super(props);

    this.state = { checked: props.accepted, clicked: false };
  }

  scrollToTop = () => {
    const scrollElement = this.scrollElement;
    if (scrollElement) {
      if ('scrollBehavior' in (document.documentElement ? document.documentElement.style : [])) {
        scrollElement.scrollTo({ top: 0, behavior: 'smooth' });
      } else {
        // We set scrollTop = 0 instead of using scrollTo because of MS Edge bug
        // https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/15534521/
        scrollElement.scrollTop = 0;
      }
    }
  };

  handleCheckChange = () => {
    this.setState(({ checked }) => ({ checked: !checked }));
  };

  handleStartClick = () => {
    this.setState({ clicked: true });
    this.props.onStartClick();
  };

  render() {
    const { kind, tagline, timelines, active = 0 } = this.props;
    return (
      <div className={`h100 ${THEME[kind]}`}>
        <article
          className={`zkai ${THEME[kind]}`}
          ref={(r) => {
            this.scrollElement = r;
          }}
        >
          <header className="zkaiHeader zkaiContainer">
            <img alt="zkai-sonyged-logo" className="zkaiHeader-logo" src={ZkaiSonygedLogo} />
          </header>

          <section className="zkaiHero zkaiContainer">
            <div className="zkaiHero-tag">{tagline}</div>
            <div className="zkaiHero-content">
              <HeroThumbnail
                kind={kind}
                alt={`${kind} shop`}
                className="zkaiHero-thumbnail zkaiHero-thumbnail--large"
              />
              <h2 className="zkaiHero-heading">
                <img alt="zkai" src={ZProTitle} />
              </h2>
              <HeroThumbnail
                kind={kind}
                alt={`${kind} shop`}
                className="zkaiHero-thumbnail zkaiHero-thumbnail--small"
              />
              <p className="zkaiHero-text gray66-color">
                ソニー・グローバルエデュケーションのプログラミング的思考を育む教育サービスと、Z会の指導ノウハウを融合し、協業で作り上げた体験型プログラミング教材です。
              </p>
            </div>

            <div className="zkaiHero-cta">
              <input
                className="zkaiHero-checkbox"
                type="checkbox"
                name="eula_check"
                id="eula_check"
                checked={this.state.checked}
                onChange={this.handleCheckChange}
              />
              <label className="zkaiHero-label" htmlFor="eula_check">
                <span>
                  <a className="zkai-link" target="_blank" href="/z-pro-term">
                    利用規約
                  </a>
                  および
                  <a className="zkai-link" target="_blank" href="/z-pro-privacy">
                    プライバシーポリシー
                  </a>
                  に同意します。
                </span>
              </label>
              <LoadingButton.attention
                disabled={!this.state.checked || this.state.clicked}
                onClick={this.handleStartClick}
                className={`zkaiHero-btn ${THEME[kind]}`}
              >
                はじめる
              </LoadingButton.attention>
            </div>
          </section>

          <div className="zkaiSection zkaiSection--note secondary8-bg-color gray80-color">
            <div className="zkaiContainer">このページは、おうちの方といっしょに読んでください。</div>
          </div>

          <div className="zkaiSection gray10-bg-color">
            <div className="zkaiContainer">
              <h2 className="zkaiSection-title secondary100-color">おうちの方へ</h2>
              <p className="zkaiSection-text gray66-color">{PARENT_NOTE[kind]}</p>
              <Button.normal className="zkaiSection-btn">
                <a href="https://www.zkai.co.jp/el/programming/zpro-faq/" rel="noopener noreferrer" target="_blank">
                  よくあるご質問 (FAQ)
                </a>
              </Button.normal>
            </div>
          </div>

          <section className="zkaiSection tertiary100-bg-color">
            <div className="zkaiContainer">
              <div className={`zkaiSection-panelTitle zkaiSection-panelTitle--${THEME[kind]}`}>
                {'ミッション　年4回配信'}
              </div>
              <div className="zkaiSection-text">
                <p>{TITLE[kind]}</p>
                <small>※ミッションは該当期間のもののみ取り組めます。</small>
              </div>
              <ul className="zkaiTimeline">
                <li
                  className={`zkaiTimeline-item ${0 < active ? 'zkaiTimeline-item--past' : ''} ${
                    0 === active ? 'zkaiTimeline-item--active' : ''
                  }`}
                >
                  <div className="zkaiTimeline-content">
                    <h3 className="zkaiTimeline-heading gray100-color">
                      <span className="secondary100-color">4-6月号</span>
                      {timelines[0].title}
                    </h3>
                    <div className="zkaiTimeline-text">{timelines[0].text}</div>
                  </div>
                </li>
                <li
                  className={`zkaiTimeline-item ${1 < active ? 'zkaiTimeline-item--past' : ''} ${
                    1 === active ? 'zkaiTimeline-item--active' : ''
                  }`}
                >
                  <div className="zkaiTimeline-content">
                    <h3 className="zkaiTimeline-heading gray100-color">
                      <span className="secondary100-color">7-9月号</span>
                      {timelines[1].title}
                    </h3>
                    <div className="zkaiTimeline-text">{timelines[1].text}</div>
                  </div>
                </li>
                <li
                  className={`zkaiTimeline-item ${2 < active ? 'zkaiTimeline-item--past' : ''} ${
                    2 === active ? 'zkaiTimeline-item--active' : ''
                  }`}
                >
                  <div className="zkaiTimeline-content">
                    <h3 className="zkaiTimeline-heading gray100-color">
                      <span className="secondary100-color">10-12月号</span>
                      {timelines[2].title}
                    </h3>
                    <div className="zkaiTimeline-text">{timelines[2].text}</div>
                  </div>
                </li>
                <li
                  className={`zkaiTimeline-item ${3 < active ? 'zkaiTimeline-item--past' : ''} ${
                    3 === active ? 'zkaiTimeline-item--active' : ''
                  }`}
                >
                  <div className="zkaiTimeline-content">
                    <h3 className="zkaiTimeline-heading gray100-color">
                      <span className="secondary100-color">{this.props.is6th ? '1-2' : '1-3'}月号</span>
                      {timelines[3].title}
                    </h3>
                    <div className="zkaiTimeline-text">{timelines[3].text}</div>
                  </div>
                </li>
                <li className="zkaiTimeline-info">
                  <span>
                    ※「プログラミング学習Z-pro」は、小学生コース本科および小学生タブレットコースをご受講の方に提供しています。
                  </span>
                </li>
              </ul>
            </div>

            <div className="zkaiContainer">
              <div className={`zkaiSection-panelTitle zkaiSection-panelTitle--${THEME[kind]}`}>
                {'フィールド　通年利用'}
              </div>
              <div className="zkaiSection-text">
                <p>
                  与えられたテーマについて、試行錯誤しながら、よりよい結果を導くことに挑戦します。繰り返し挑戦することで、「プログラミング的思考」を伸ばします。
                </p>
                <small>※小学生コース本科および小学生タブレットコースをご受講中ならいつでも利用できます。</small>
              </div>
              <ul className="zkaiTimeline">
                <li className={`zkaiTimeline-item zkaiTimeline-item--active zkaiTimeline-item--noNumber`}>
                  <div className="zkaiTimeline-content">
                    <h3 className="zkaiTimeline-heading gray100-color">{FIELD[kind].title}</h3>
                    <div className="zkaiTimeline-text">{FIELD[kind].text}</div>
                  </div>
                </li>
              </ul>
            </div>

            <div className="zkaiContainer">
              <div className={`zkaiSection-panelTitle zkaiSection-panelTitle--${THEME[kind]}`}>
                「プログラミング学習 Z-pro」で身につく力とは？
              </div>
              <div className="zkaiSection-text gray66-color">
                <span className="secondary300-color">「答えが一つではないもの」、</span>
                <span className="secondary300-color">「常に状況がかわるもの」</span>
                に対し、
                <span className="secondary300-color">トライ&amp;エラー</span>
                を繰り返しながら解決法を発見していくことで身につく「論理的思考力」「問題解決力」「創造力」の3つです。
              </div>

              <div className="zkaiExplain">
                <VennDiagram kind={kind} className="zkaiExplain-thumbnail" alt="explain" />

                <ul className="zkaiExplain-list">
                  <li className="zkaiExplain-point">
                    <h3 className={`zkaiExplain-title zkaiExplain-title--blue ${THEME[kind]}`}>論理的思考力</h3>
                    <p className="zkaiExplain-text">
                      知識をただ積み重ねるだけではなく、身につけた知識をもとに
                      <span className="secondary300-color">筋道を立てて論理的に考える力</span>
                      です。
                    </p>
                    <p className="zkaiExplain-text">
                      近い将来、
                      <span className="secondary300-color">他者と協働する場面</span>
                      に備え、自分の考えを適切に伝える力をあわせて身につけておくことが重要です。
                    </p>
                  </li>
                  <li className="zkaiExplain-point">
                    <h3 className={`zkaiExplain-title zkaiExplain-title--pink ${THEME[kind]}`}>問題解決力</h3>
                    <p className="zkaiExplain-text">
                      問題に対し、「問題点はどこか」「どう対処すればよいか」「効率的に解決するには」など、解決するための
                      <span className="secondary300-color">手立てを具体的に考える力</span>
                      です。
                    </p>
                    <p className="zkaiExplain-text">
                      将来、各分野で社会の中核を担うために、必須となる能力といえるでしょう。
                    </p>
                  </li>

                  <li className="zkaiExplain-point">
                    <h3 className={`zkaiExplain-title zkaiExplain-title--yellow ${THEME[kind]}`}>創造力</h3>
                    <p className="zkaiExplain-text">
                      アイデアを形にし、新しい価値を
                      <span className="secondary300-color">自分で創り出す力</span>
                      です。
                    </p>
                    <p className="zkaiExplain-text">
                      ひらめきや発見は突然うまれるものではありません。情報を分析し、「こうしたらどうなるだろう」と試行錯誤したりしながら考えることでうまれます。一朝一夕で身につく力ではないため、幼い頃からの積み重ねが大切です。
                    </p>
                  </li>
                </ul>
              </div>
            </div>

            <div className="zkaiScrollup secondary100-color zkaiContainer zkaiContainer--large">
              ページの先頭へ
              <button className="proc-button proc-button--light" onClick={this.scrollToTop.bind(this)}>
                <i className="proc-button-icon icon-proc-pagetop" />
              </button>
            </div>
          </section>

          <footer className="zkaiFooter zkaiContainer zkaiContainer--large">
            <div className="zkaiFooter-logo footer-item">
              <div className="zkaiFooter-logoImg" />

              <div className="zkaiFooter-copyright">© 2019 Sony Global Education, Inc.</div>
            </div>
            <ul className="zkaiFooter-linkList">
              <li className="zkaiFooter-linkItem">
                <a target="_blank" href="/z-pro-privacy">
                  プライバシーポリシー
                </a>
              </li>
              <li className="zkaiFooter-linkItem">
                <a target="_blank" href="/z-pro-term">
                  サービス利用規約
                </a>
              </li>
              <li className="zkaiFooter-linkItem">
                <a target="_blank" href="/z-pro-external-destination-list">
                  外部送信一覧
                </a>
              </li>
            </ul>
          </footer>
        </article>
      </div>
    );
  }
}

export default ZkaiPage;
